module.exports = __webpack_public_path__ + "img/smoke.19326e6e.gif";